import React from "react";

export default function ConsentCheckbox({ id, checked, onChange }) {
  return (
    <label htmlFor={id} className="mt-4 flex items-start gap-2.5 text-sm text-slate-600 cursor-pointer select-none">
      <input id={id} data-testid={id} type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 h-4 w-4 shrink-0 rounded border-slate-300 accent-primary" />
      <span>Acconsento a pubblicare questa recensione sul sito con il mio nome e la mia professione</span>
    </label>
  );
}
